import { createSelector } from 'reselect'

const selectSalesman = state => state.salesman

export const selectCurrentSalesman = createSelector(
    [selectSalesman],
    (salesman) => salesman.currentSalesman 
)